import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import Markdown from 'markdown-to-jsx';
import { ChildrenPropType, StylePropType } from '../../services/proptypes';
var defaultProps = {
  className: '',
  style: {},
  content: '',
  show: true
};
export default function MarkdownContent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    content = _ref.content,
    children = _ref.children,
    show = _ref.show;
  var hasNoContent = _isEmpty(content) && _isEmpty(children);
  if (hasNoContent || !show) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Markdown, {
    className: className,
    style: style
  }, content || children);
}
MarkdownContent.defaultProps = defaultProps;